import _ from 'lodash';
import pdfPageTitle from './PDFPageTitle';

export default ({ title, description, colorClass = 'print.primary.7' }, { sectionsToPrint: sections, printAllPages }) => ({
    ...pdfPageTitle({ title, description, colorClass }),
    introSvg: {
        // position: 'content',
        // y: 'h-2-1/2',
        mt: 10,
        h: 'h-10-1/2',
        src: 'introSVG.svg',
        onload: (svg) => {
            svg.selectAll('.page').each(function () {
                const section = _.find(sections, { id: this.id });
                const pageLabel = section ? `page ${section.num}` : '**';
                d3.select(this).select('tspan').text(pageLabel).attr('font-style', 'italic');
            });
        }
    },
    footer: !printAllPages && {
        text: '** This is a custom report. The user chose to exclude this section.'
    }
});
